module.exports = __webpack_public_path__ + "static/media/6.a1cefc2d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/6.wav
// module id = 34
// module chunks = 0